module.exports = __webpack_public_path__ + "img/Abstract-LBA.aec6ca5e.svg";